// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// import $ from "jquery"

// window.jQuery = $
// window.$ = $
// global.jQuery = $
// global.$ = $

const jQuery = require("jquery")
global.$ = window.$ = jQuery
global.jQuery = window.jQuery = jQuery

import "bootstrap"
import "../stylesheets/application"
import "select2/dist/css/select2.min.css"
import select2 from 'select2'

import "summernote"

require("trix")
require("@rails/actiontext")

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")

function formatMyr(value) {
    return new Intl.NumberFormat('ms-MY', {
        style: 'currency',
        currency: 'MYR',
        minimumFractionDigits: 2
    }).format(value);
}

$(function () {
    const csrfToken = $('meta[name="csrf-token"]').attr('content');

    $('.summernote').summernote({
        height: 500
    })
    $('.data-tables').DataTable({
        "stateSave": true,
    })
    $('.select2-form').select2()

    // Contracts server-side DataTable
    if ($('#contracts-table').length) {
        const url = $('#contracts-table').data('url');
        $('#contracts-table').DataTable({
            processing: true,
            serverSide: true,
            stateSave: true,
            ajax: {
                url: url,
                type: 'GET',
                headers: { 'X-CSRF-Token': csrfToken }
            },
            columns: [
                {
                    data: 'tender',
                    width: '30%',
                    render: function (d) {
                        return `
            <div class="tw-text-xs">
              <a href="${d.url}"><div class="tw-font-bold">${d.number}</div>${d.tender_name}</a>
              <div class="tw-mt-1">
                CLIENT: <a href="/clients/${d.client_id}">${d.client_name}</a><br>
                PAYMASTER: <a href="/paymasters/${d.paymaster_id}">${d.paymaster_name}</a>
              </div>
            </div>`;
                    }
                },
                {
                    data: 'rate',
                    width: '10%',
                    render: function (d) {
                        const inner = `
            <p class="tw-font-bold">Profit Rate:</p>${d.profit_rate} %<br>
            <p class="tw-font-bold">Service Charge:</p>${d.service_charge_rate} %`;
                        if (d.edit_url) {
                            return `<a href="${d.edit_url}" class="tw-link-blue tw-text-xs">${inner}</a>`;
                        }
                        return `<div class="tw-text-xs">${inner}</div>`;
                    }
                },
                { data: 'sector', className: 'tw-text-xs align-middle' },
                { data: 'site', className: 'tw-text-xs align-middle' },
                { data: 'nature', className: 'tw-text-xs align-middle' },
                {
                    data: null,
                    className: 'align-middle',
                    render: function (d) {
                        const isOngoing = d.project_status === 'on_going';
                        const label = isOngoing ? 'On Going' : 'Complete';
                        const cls = isOngoing
                            ? 'tw-badge-purple tw-badge-xs'
                            : 'tw-badge-green tw-badge-xs';
                        const confirm = isOngoing
                            ? 'Mark this project as complete?'
                            : 'Mark this project as on going?';
                        return `
            <a href="${d.update_status_url}"
               class="${cls}"
               data-method="patch"
               data-confirm="${confirm}"
               rel="nofollow">${label}</a>`;
                    }
                },
                {
                    data: 'value',
                    className: 'text-right align-middle',
                    render: function (v) {
                        return `<div class="tw-badge-green">${formatMyr(v)}</div>`;
                    }
                },
                {
                    data: 'factored_amount',
                    className: 'text-right align-middle',
                    render: function (v) {
                        return `<div class="tw-badge-green">${formatMyr(v)}</div>`;
                    }
                },
                {
                    data: 'disbursed_amount',
                    className: 'text-right align-middle',
                    render: function (v) {
                        return `<div class="tw-badge-green">${formatMyr(v)}</div>`;
                    }
                },
                {
                    data: null,
                    className: 'text-right align-middle',
                    render: function (d) {
                        let html = `<div class="tw-badge-green">${formatMyr(d.balance)}</div>`;
                        if (d.show_warning) {
                            html += `<div class="tw-badge-2xs tw-badge-red">${d.used_pct}% used</div>`;
                        }
                        return html;
                    }
                },
                {
                    data: null,
                    orderable: false,
                    className: 'text-right align-middle',
                    render: function (d) {
                        return `
            <div class="tw-flex tw-gap-1">
              <a href="${d.edit_url}" class="btn btn-sm btn-warning">
                <i class="material-icons align-middle md-16">edit</i> Edit
              </a>
              <a href="${d.delete_url}"
                 data-method="delete"
                 data-confirm="Are you sure? This action cannot be undone."
                 rel="nofollow"
                 class="btn btn-sm btn-danger">
                <i class="material-icons align-middle md-16">delete_forever</i> Delete
              </a>
            </div>`;
                    }
                }
            ],
            pageLength: 25,
            order: [[0, 'asc']]
        });
    }
})